import React from 'react';

const TrailButton = ({ children, className = '' }) => {
  return (
    <div className={`trail-wrap ${className}`} data-testid="trail-button-wrapper">
      <div className="trail-border" aria-hidden="true">
        <div className="trail-spin" />
      </div>
      {children}
    </div>
  );
};

export default TrailButton;
